import { createFileRoute } from '@tanstack/react-router'
import { ChangePasswordScreen } from '@web/app/features/profile'

export const Route = createFileRoute('/_index/cuenta/cambiarContrasena')({
  component: ChangePasswordScreen,
  staticData: {
    metaRoute: {
      title: 'Cambiar Contraseña',
      order: 2,
    },
  },
})
